import CheckWebApiConnectionRequestModelBase from '../_generated/modelBases/check-web-api-connection-request-model-base';

export default class CheckWebApiConnectionRequestModel extends CheckWebApiConnectionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
